const websocketEndpoint = () => {
  if (process.env.NODE_ENV === 'development') return 'http://localhost:8084/websocket/callws';

  return '/websocket/callws';
};

export { websocketEndpoint };
